module.exports = __webpack_public_path__ + "static/media/IMG_8762.ed3bd062.jpg";